import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { isEmpty } from 'lodash';
import VerbText from '../VerbText';

const Warning = ({ messageTextProp, warningColor, valuesToInject = {} }) => {
    if (isEmpty(messageTextProp)) {
        return null;
    }

    return (
        <div className={cns('warning-component-container', `${warningColor || ''}`)}>
            <div className={cns('row', `msg-container g-0`)}>
                <i className={cns('icon', `fas fa-exclamation-triangle ${warningColor || ''}`)} />
                <div className={'warning-msg'}>
                    <VerbText
                        messageId={messageTextProp.messageId}
                        defaultMessage={messageTextProp.defaultMessage}
                        valuesToInject={valuesToInject}
                    />
                </div>
            </div>
        </div>
    );
};

Warning.propTypes = {
    messageTextProp: PropTypes.object,
    warningColor: PropTypes.string,
    valuesToInject: PropTypes.object
};

export default Warning;
